import Axios from 'axios';

/**
 * An Axios instance used for API queries. Not meant for general use.
 *
 * @internal
 * @private
 */
var axios = Axios.create({
    baseURL: 'https://api.pwnedpasswords.com'
});

export default axios;
//# sourceMappingURL=axiosInstance2.js.map



//////////////////
// WEBPACK FOOTER
// ./~/hibp/es/axiosInstance2.js
// module id = ./node_modules/hibp/es/axiosInstance2.js
// module chunks = 2